export type Locale = 'ru' | 'en';

export interface Translations {
  chatIntro: {
    openInTelegram: string;
    privacyPolicy: string;
    termsOfService: string;
    and: string;
    policyConsent: string;
  };
  messageList: {
    welcome: string;
    writeMessage: string;
    telegramBot: string;
    alsoAvailable: string;
    loading: string;
  };
  messageInput: {
    placeholder: string;
    dropImages: string;
    maxImages: string;
    moreImages: string;
    attachImage: string;
    sendMessage: string;
  };
  chatButton: {
    openChat: string;
  };
  chatHeader: {
    minimizeChat: string;
    defaultName: string;
    defaultSubtitle: string;
  };
  welcomeScreen: {
    title: string;
    subtitle: string;
    telegramHint: string;
    telegramButton: string;
  };
  assistantCard: {
    description: string;
    telegramButton: string;
    backButton: string;
    newChatButton: string;
    newChatConfirm: string;
  };
}

const ru: Translations = {
  chatIntro: {
    openInTelegram: 'Открыть в Telegram',
    privacyPolicy: 'политикой конфиденциальности',
    termsOfService: 'условиями использования',
    and: 'и',
    policyConsent: 'Отправляя сообщение, вы соглашаетесь с',
  },
  messageList: {
    welcome: '👋 Добро пожаловать!',
    writeMessage: 'Напишите сообщение, чтобы начать общение',
    telegramBot: 'Telegram-бот',
    alsoAvailable: 'Также доступен',
    loading: 'Загрузка...',
  },
  messageInput: {
    placeholder: 'Сообщение...',
    dropImages: 'Перетащите изображения для загрузки',
    maxImages: 'Максимум изображений:',
    moreImages: 'Можно добавить ещё изображений:',
    attachImage: 'Прикрепить изображение',
    sendMessage: 'Отправить сообщение',
  },
  chatButton: {
    openChat: 'Открыть чат',
  },
  chatHeader: {
    minimizeChat: 'Свернуть чат',
    defaultName: 'AI Ассистент',
    defaultSubtitle: '',
  },
  welcomeScreen: {
    title: 'Добро пожаловать!',
    subtitle: 'Напишите сообщение, чтобы начать диалог',
    telegramHint: 'Также доступен чат-бот Telegram',
    telegramButton: 'в Telegram',
  },
  assistantCard: {
    description: 'ИИ-ассистент готов помочь Вам в ваших задачах и подробно рассказать о возможностях платформы',
    telegramButton: 'Перейти в чат-бот Telegram',
    backButton: 'Вернуться к чату',
    newChatButton: 'Удалить все сообщения и начать чат заново',
    newChatConfirm: 'Все сообщения будут удалены. Продолжить?',
  },
};

const en: Translations = {
  chatIntro: {
    openInTelegram: 'Open in Telegram',
    privacyPolicy: 'privacy policy',
    termsOfService: 'terms of service',
    and: 'and',
    policyConsent: 'By sending a message, you agree to the',
  },
  messageList: {
    welcome: '👋 Welcome!',
    writeMessage: 'Send a message to start the conversation',
    telegramBot: 'Telegram bot',
    alsoAvailable: 'Also available:',
    loading: 'Loading...',
  },
  messageInput: {
    placeholder: 'Message...',
    dropImages: 'Drop images here to upload',
    maxImages: 'Maximum images:',
    moreImages: 'More images can be added:',
    attachImage: 'Attach image',
    sendMessage: 'Send message',
  },
  chatButton: {
    openChat: 'Open chat',
  },
  chatHeader: {
    minimizeChat: 'Minimize chat',
    defaultName: 'AI Assistant',
    defaultSubtitle: '',
  },
  welcomeScreen: {
    title: 'Welcome!',
    subtitle: 'Send a message to start the conversation',
    telegramHint: 'Telegram chat bot also available',
    telegramButton: 'Telegram',
  },
  assistantCard: {
    description: 'AI assistant is ready to help you with your tasks and tell you about the platform capabilities',
    telegramButton: 'Go to Telegram chat bot',
    backButton: 'Back to chat',
    newChatButton: 'Delete all messages and start chat over',
    newChatConfirm: 'All messages will be deleted. Continue?',
  },
};

const translations: Record<Locale, Translations> = { ru, en };

export function detectLocale(): Locale {
  const htmlLang = document.documentElement.lang;
  if (htmlLang) {
    return htmlLang.toLowerCase().startsWith('ru') ? 'ru' : 'en';
  }
  const browserLang = navigator.language || (navigator as { userLanguage?: string }).userLanguage || 'en';
  return browserLang.toLowerCase().startsWith('ru') ? 'ru' : 'en';
}

export function getTranslations(locale: Locale): Translations {
  return translations[locale];
}
